import { Permissions } from '../../../../models/enums/permissions';
import cloneDeep from 'lodash/cloneDeep';
import * as React from 'react';
import * as Forms from '../../../../components/form-elements/_index';
import { DataGroupHeader } from '../../../../components/data-group/DataGroupHeader';
import { InputLabel, PageActions, TextInput } from '../../../../components/form-elements/_index';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { DivisionMetadata } from '../../../../models/ordering/enums/division';
import { DealerSvc } from '../../../../shared/services/dealer-service';
import { StatusCode } from '../../../../utils/api';
import { PageNames } from '../../../../utils/app-constants';
import { history } from '../../../../utils/history';
import { formatCurrency } from '../../../../utils/currency-formatter';
import { DealerContactTable } from '../components/DealerContactTable';
import { DealerSalesTable } from '../components/DealerSalesTable';
import { DealerPaymentTerm, DealerRead } from '../../../../support/models/dealers/dealer-read';
import '../../../../support/styles.scss';
import { ActionEditDealerInfo } from '../components/ActionEditDealerInfo';
import { SelectListItem } from '../../../../models/utilities/selectlist-item';
import { CreditHoldReasonMetadata } from '../../../../support/models/enums/credit-hold-reason';
import { AppUtils } from '../../../../utils/app-utils';
import { AddressMapDisplay } from '../../../../transportation/components/mapping/AddressMapDisplay';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { DayOfWeekMetadata } from '../../../../models/enums/day-of-week';
import { ShippingMethodSelectList } from '../../../../models/enums/shipping-method';
import { ShipToAddressRead } from '../../../../shared/models/ship-to-address-read';

// #region Component State and Props

interface IProps {
    dealer: DealerRead;
    addresses: ShipToAddressRead[];
}

// #endregion

export const DealerBasicInfoScene = (props: IProps) => {

    const getUrlDisplay = () => {
        var addr = props.dealer.billingAddress;
        return `\n${addr.addressLine1}\n${addr.addressLine2 ? `${addr.addressLine2}\n` : ''}${addr.city}, ${addr.stateProvince} ${addr.postalCode}`;
    }

    const [dealer, setDealer] = React.useState({} as DealerRead);
    const [service] = React.useState(new DealerSvc());
    const [editDealer, setEditDealer] = React.useState({} as DealerRead);
    const [showInfoFlyout, setShowInfoFlyout] = React.useState(false);
    const [creditHoldReasons] = React.useState(() => {
        const reasons: Array<SelectListItem<string>> = [];
        reasons.push(new SelectListItem({
            id: '', name: '<none>'
        }));
        for (let i in CreditHoldReasonMetadata) {

            let reason = CreditHoldReasonMetadata[i as keyof typeof CreditHoldReasonMetadata];

            reasons.push(new SelectListItem({
                id: reason.value, name: reason.display
            }));
        }
        return reasons
    });

    const [booleanSelectList] = React.useState(() => {
        const results: Array<SelectListItem<string>> = [];
        results.push(new SelectListItem({
            id: true, name: 'Yes',
        }));
        results.push(new SelectListItem({
            id: false, name: 'No'
        }));
        return results
    });

    const [shipToAddresses] = React.useState(() => {
        const addresses: Array<SelectListItem<string>> = [];
        addresses.push(new SelectListItem({
            id: '', name: '<none>'
        }));
        for (let i = 0; i < props.addresses.length; i++) {
            const address = props.addresses[i];
            addresses.push(new SelectListItem({
                id: address.id, name: address.name
            }));
        }
        return addresses
    });

    React.useEffect(() => {
        if (!dealer.id) {
            setDealer(props.dealer);
        }
    })

    async function getDealer(id: string) {

        if (id) {
            const result = await service.getFullDealer(id);
            if (result.status === StatusCode.Success) {
                setDealer(result.data.dealer);
                return;
            }
        }
        else {
            history.goBack();
        }
    }

    const showEditBasicInfo = () => {
        const t = cloneDeep(dealer);
        setEditDealer(t);
        setShowInfoFlyout(true);
    };

    const onSetBasicInfoSuccess = () => {
        hideEditBasicInfo();
        getDealer(dealer.id);
    };

    const hideEditBasicInfo = async () => {
        setEditDealer({} as unknown as DealerRead);
        setShowInfoFlyout(false);
    };

    return dealer.id ?
        <PageContent pageName={PageNames.SUPPORT_DEALERS_DETAILS}>
            <PageBody>
                <div className="row">
                    <div className="col">
                    </div>
                    <div className="col-md-auto">
                        <div className="page-actions">
                            <PageActions
                                id="dealer-edit-form"
                                onEdit={showEditBasicInfo}
                                editPermissions={[
                                    Permissions.SupportDealersEdit
                                ]}
                            />
                        </div>
                     </div>
                </div>

                <DataGroupHeader title="Basic Information" />
                <div className="row address-display billing-address">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-12">
                                <TextInput
                                    type="text"
                                    id="rsm"
                                    label="RSM"
                                    onChange={() => { return; }}
                                    value={`${dealer.rsmName} [${dealer.regionId}]`}
                                    disable={true} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <InputLabel
                                        htmlFor="">
                                        Billing Address
                                    </InputLabel>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <textarea
                                                    id='address-line1'
                                                    className="form-control"
                                                    disabled
                                                    value={getUrlDisplay()}
                                                    onChange={() => { return; }}
                                                />
                                            </div>
                                            {
                                                dealer.phoneNumber
                                                    ? <div className="form-group">
                                                        <input
                                                            id='address-phone'
                                                            className="form-control"
                                                            type="text"
                                                            disabled
                                                            value={`tel: ${AppUtils.formatPhone(dealer.phoneNumber)}`}
                                                            onChange={() => { return; }}
                                                        />
                                                    </div>
                                                    : null
                                            }
                                            {
                                                dealer.faxNumber
                                                    ? <div className="form-group">
                                                        <input
                                                            id='address-fax'
                                                            className="form-control"
                                                            type="text"
                                                            disabled
                                                            value={`fax: ${AppUtils.formatPhone(dealer.faxNumber!)}`}
                                                            onChange={() => { return; }}
                                                        />
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TextInput
                                                type="text"
                                                id="cutoffDay"
                                                label="Default Cutoff Day of Week"
                                                onChange={() => { return; }}
                                                value={DayOfWeekMetadata[dealer.cutoffDay]?.display ?? ''}
                                                disable={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <HasPermission requiredPermissions={[
                            Permissions.SupportDealersView
                        ]}>
                            <div className="location">
                                {
                                    (dealer.billingAddress.latitude && dealer.billingAddress.longitude)
                                        ? <AddressMapDisplay
                                            center={{
                                                lat: dealer.billingAddress.latitude,
                                                lng: dealer.billingAddress.longitude
                                            }} />
                                        : <div className="no-address">Unable to load address</div>
                                }
                            </div>
                        </HasPermission>
                    </div>
                </div>

                <DataGroupHeader title="Invoicing Information" />
                <div className="row">
                    {
                        dealer.paymentTerms.map((itm: DealerPaymentTerm) =>
                            <div className="col-md-4" key={itm.division}>
                                <TextInput
                                    type="text"
                                    id="paymentTerms"
                                    label={`${DivisionMetadata[itm.division].display} Payment Terms`}
                                    onChange={() => { return; }}
                                    value={itm.paymentTermId}
                                    disable={true} />
                            </div>
                        )
                    }
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <TextInput
                            type="text"
                            id="currency"
                            label="Currency"
                            onChange={() => { return; }}
                            value={dealer.currencyId}
                            disable={true} />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            type="text"
                            id="taxRate"
                            label="Tax Rate"
                            onChange={() => { return; }}
                            value={
                                dealer.isTaxExempt
                                    ? 'TAX EXEMPT'
                                    : dealer.taxRate
                            }
                            disable={true} />
                    </div>
                    <div className="col-md-3">
                        <Forms.SelectInput
                            id="freightTaxable"
                            testID="freight-taxable"
                            label="Freight Taxable"
                            onChange={() => { return; }}
                            options={booleanSelectList}
                            value={dealer.isFreightTaxable}
                            disable={true} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Forms.SelectInput
                            id="isOnCreditHold"
                            testID="dealer-is-on-credit-hold"
                            label="Is On Credit Hold"
                            onChange={() => { return; }}
                            options={booleanSelectList}
                            value={dealer.isOnCreditHold}
                            disable={true} />
                    </div>
                    <div className="col-md-6">
                        <Forms.SelectInput
                            id="creditHoldReason"
                            testID="dealer-basic-info-credit-hold-reason"
                            label="Credit Hold Reason"
                            onChange={() => { return; }}
                            options={creditHoldReasons}
                            value={dealer.creditHoldReason}
                            disable={true} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Forms.SelectInput
                            id="defaultShippingMethod"
                            testID="default-shipping-method"
                            label="Default Shipping Method"
                            onChange={() => { return; }}
                            options={ShippingMethodSelectList}
                            value={dealer.defaultShippingMethod}
                            disable={true} />
                    </div>
                    <div className="col-md-6">
                        <Forms.SelectInput
                            id="defaultShipToAddressId"
                            testID="default-ship-to-address-id"
                            label="Default Ship-to Address"
                            onChange={() => { return; }}
                            options={shipToAddresses}
                            value={dealer.defaultShipToAddressId}
                            disable={true} />
                    </div>
                </div>

                <div className="row divider-row">
                    <div className="col pt-3 pb-3">
                        <div className="row">
                            <div className="col">
                                <DataGroupHeader title="Transportation Information" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <TextInput
                                    type="text"
                                    id="minFreightCD"
                                    label="Minimum Freight (CD)"
                                    onChange={() => { return; }}
                                    value={dealer.minimumFreightCD ? formatCurrency(dealer.minimumFreightCD) : 0.0}
                                    disable={true} />
                            </div>
                            <div className="col-md-6">
                                <TextInput
                                    type="text"
                                    id="maxFreightCD"
                                    label="Maximum Freight (CD)"
                                    onChange={() => { return; }}
                                    value={dealer.maximumFreightCD ? formatCurrency(dealer.maximumFreightCD) : 0.0}
                                    disable={true} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <TextInput
                                    type="text"
                                    id="minFreightRS"
                                    label="Minimum Freight (RS)"
                                    onChange={() => { return; }}
                                    value={dealer.minimumFreightRS ? formatCurrency(dealer.minimumFreightRS) : 0.0}
                                    disable={true} />
                            </div>
                            <div className="col-md-6">
                                <TextInput
                                    type="text"
                                    id="maxFreightRS"
                                    label="Maximum Freight (RS)"
                                    onChange={() => { return; }}
                                    value={dealer.maximumFreightRS ? formatCurrency(dealer.maximumFreightRS) : 0.0}
                                    disable={true} />
                            </div>
                        </div>

                    </div>
                </div>

                <h2 className='datagroup-header flex-display'>
                    <span>Communication Information</span>
                    <div className={
                        "mail-documents-status " + (dealer.invoiceDocumentMailed ? 'green' : '')
                    }>
                        <p>
                            {
                                dealer.invoiceDocumentMailed
                                    ? <span>Receives Mailed Invoice</span>
                                    : <span>Doesn't Receive Mailed Invoice</span>
                            }
                            {
                                dealer.invoiceDocumentMailed
                                    ? <i className="la la-check-circle-o green" />
                                    : <i className="la la-times-circle-o red" />
                            }
                        </p>
                    </div>
                </h2>

                <DealerContactTable contacts={dealer.contacts} />

                <div className="row"><br/><br/></div>
                <DataGroupHeader title="Preferences" />
                <div className="row">
                    <div className="col-md-6">
                        <Forms.SelectInput
                            id="bulkBundleStruts"
                            testID="dealer-bulk-bundle-struts"
                            label="Bulk-Bundle Struts"
                            onChange={() => { return; }}
                            options={booleanSelectList}
                            value={dealer.preferences?.bulkBundleStruts}
                            disable={true} />
                    </div>
                    <div className="col-md-6">
                        <Forms.SelectInput
                            id="assembleSprings"
                            testID="assemble-springs"
                            label="Assemble Springs"
                            onChange={() => { return; }}
                            options={booleanSelectList}
                            value={dealer.preferences?.assembleSprings}
                            disable={true} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Forms.SelectInput
                            id="steelBearingsOnSprings"
                            testID="dealer-steel-bearings-on-springs"
                            label="Steel Bearings on Springs"
                            onChange={() => { return; }}
                            options={booleanSelectList}
                            value={dealer.preferences?.steelBearingsOnSprings}
                            disable={true} />
                    </div>
                    <div className="col-md-6">
                        <Forms.SelectInput
                            id="flipHorizontalAngle"
                            testID="flip-horizontal-angle"
                            label="Flip Horizontal Angle"
                            onChange={() => { return; }}
                            options={booleanSelectList}
                            value={dealer.preferences?.flipHorizontalAngle}
                            disable={true} />
                    </div>
                </div>

                <HasPermission requiredPermissions={[ Permissions.SupportDealersSales ]}>
                    <div className="row"><br/><br/></div>
                    <DealerSalesTable dealerId={dealer.id} />
                </HasPermission>

                <ActionEditDealerInfo
                    visible={showInfoFlyout}
                    onSuccess={onSetBasicInfoSuccess}
                    onClose={hideEditBasicInfo}
                    dealer={editDealer}
                    addresses={props.addresses}
                />
            </PageBody>
        </PageContent>
        : null;

};
